import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';

const propTypes = {
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

const TablePagination = ({
  page,
  onPageChange,
  totalPages,
  loading,
  className,
}) => {
  const classes = classNames({
    'd-flex justify-content-between align-items-center': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <Button
        disabled={page === 0 || loading}
        btnSize="xs"
        onClick={() => {
          onPageChange(page - 1);
        }}
      >
        Previous page
      </Button>

      <span className="text-sm">
        Page: {page + 1} / {totalPages}
      </span>

      <Button
        disabled={page + 1 === totalPages || loading}
        btnSize="xs"
        onClick={() => {
          onPageChange(page + 1);
        }}
      >
        Next page
      </Button>
    </div>
  );
};

TablePagination.propTypes = propTypes;

export default TablePagination;
